import { render, staticRenderFns } from "./FormProgram.vue?vue&type=template&id=23afe3e5&"
import script from "./FormProgram.vue?vue&type=script&lang=js&"
export * from "./FormProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports